import { h, } from '@stencil/core';
import cn from 'classnames';
import Hammer from 'hammerjs';
import { pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
export class Slider {
  constructor() {
    this.pos = 0;
    this.handleSwipe = (e) => {
      const shiftY = (e.deltaY / this.slideWidth) * 100 > -20;
      const shiftX = (e.deltaX / this.slideHeight) * 100 > -20;
      if (this.panEnabled && (shiftY || shiftX)) {
        !this.verticalPan && this.translateY(this.pos + e.deltaY);
        this.verticalPan && this.translateX(this.pos + e.deltaX);
        if (e.isFinal) {
          if (e.type === 'panleft' || e.type === 'panup') {
            this.goToNext();
          }
          else if (e.type === 'panright' || e.type === 'pandown') {
            this.goToPrevious();
          }
          else {
            this.slideTo(this.current);
          }
        }
        else if (e.type === 'panend' || e.type === 'pancancel') {
          this.slideTo(this.current);
        }
      }
      else {
        this.slideTo(this.current);
      }
    };
    this.timing = 400;
    this.childrenClassName = 'pdp-slider > div, pdp-slider > pdp-product-card';
    this.verticalPan = false;
    this.showButtons = true;
    this.infinite = false;
    this.showPointers = false;
    this.showThumbnails = false;
    this.itemsPerSlide = 1;
    this.differentWidthOfItems = false;
    this.sliderWidth = null;
    this.sliderHeight = null;
    this.activeSlide = 0;
    this.panEnabled = true;
    this.direction = document.documentElement.dir || 'auto';
    this.smallPoint = false;
    this.smallCard = false;
    this.shortCarouselPagination = undefined;
    this.goToNext = (e) => {
      e && e.preventDefault();
      if (this.direction === 'rtl') {
        this.slideTo(Math.ceil(this.current + this.operator));
      }
      else {
        this.slideTo(Math.ceil(this.current - this.operator));
      }
    };
    this.goToPrevious = (e) => {
      e && e.preventDefault();
      if (this.direction === 'rtl') {
        this.slideTo(Math.ceil(this.current - this.operator));
      }
      else {
        this.slideTo(this.current + this.operator);
      }
    };
    this.slideCount = 0;
    this.current = this.activeSlide;
  }
  optionDidChange(activeSlide) {
    this.slideTo(activeSlide);
  }
  setPan(enabled) {
    this.panEnabled = enabled;
    this.initGesture();
  }
  slideTo(n) {
    let last;
    if (this.differentWidthOfItems) {
      last = Array.from(this.slides)
        .slice(0 - (this.slideCount - this.current))
        .reduce((sum, i) => sum + i.offsetWidth, 0) >= this.slider.offsetWidth
        ? this.slideCount
        : n - 1;
      this.current = n < 0 ? 0 : n >= last ? last : n;
      this.pos = this.current === 0
        ? 0
        : this.operator
          * Array.from(this.slides)
            .slice(0, this.current)
            .reduce((sum, i) => sum + i.offsetWidth, 0);
    }
    else {
      last = this.infinite ? 0 : Math.ceil(this.slideCount - this.itemsPerSlide);
      this.current = n < 0 ? 0 : n >= last ? last : n;
      this.pos = (this.operator * this.current * (!this.verticalPan
        ? this.slideWidth
        : this.slideHeight))
        / this.itemsPerSlide;
    }
    this.slider.classList.add('is-animating');
    const prevSlide = this.parent.querySelector(`${this.childrenClassName}.active`);
    prevSlide && prevSlide.classList.remove('active');
    this.slides[this.current] && this.slides[this.current].classList.add('active');
    if (this.showButtons) {
      this.current === last
        ? this.nextBtn && this.nextBtn.classList.add('disabled')
        : this.nextBtn && this.nextBtn.classList.remove('disabled');
      this.current === 0
        ? this.prevBtn && this.prevBtn.classList.add('disabled')
        : this.prevBtn && this.prevBtn.classList.remove('disabled');
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.slider && this.slider.classList.remove('is-animating');
      this.afterSlimSlide.emit({ current: this.current });
    }, this.timing);
    !this.verticalPan ? this.translateY(this.pos) : this.translateX(this.pos);
  }
  init() {
    var _a, _b, _c, _d;
    this.operator = -1;
    this.slides = this.parent.querySelectorAll(this.childrenClassName);
    this.slideCount = this.slides.length;
    this.slideWidth = (_a = this.sliderWidth) !== null && _a !== void 0 ? _a : this.parent.offsetWidth;
    this.slideHeight = (_b = this.sliderHeight) !== null && _b !== void 0 ? _b : this.parent.offsetHeight;
    this.itemWidth = this.slideWidth / this.itemsPerSlide;
    this.itemHeight = this.slideHeight / this.itemsPerSlide;
    this.parent.style.direction = this.direction;
    (_d = (_c = this.slides) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.classList.add('active');
    if (this.slideCount > 4 && this.verticalPan) {
      this.parent.style.marginTop = '23px';
    }
    Array.from(this.slides).forEach((el, k) => {
      el.dataset.item = k.toString();
      if (!this.differentWidthOfItems && this.slideCount > this.itemsPerSlide) {
        this.verticalPan
          ? (el.style.minHeight = `${this.itemHeight}px`)
          : (el.style.minWidth = `${this.itemWidth}px`);
      }
      Array.from(el.querySelectorAll('img')).map((i) => (i.draggable = false));
    });
    this.afterSlimInit.emit({ current: this.current });
  }
  resizeWindow() {
    this.init();
    this.slideTo(0);
  }
  initGesture() {
    if (this.sliderManager) {
      this.sliderManager.destroy();
      this.sliderManager = null;
    }
    if (this.slideCount <= this.itemsPerSlide)
      return;
    const touchAction = !this.panEnabled
      ? { touchAction: 'none' }
      : this.verticalPan
        ? { touchAction: 'pan-x' }
        : { touchAction: 'pan-y' };
    this.sliderManager = new Hammer.Manager(this.slider, Object.assign(Object.assign({}, touchAction), { recognizers: [[Hammer.Pan, { direction: Hammer.DIRECTION_ALL }]] }));
    this.sliderManager.on('panstart panmove panend pancancel panleft panright panup pandown', this.handleSwipe);
    window.addEventListener('resize', () => this.resizeWindow);
  }
  translateY(to) {
    const pos = this.direction === 'rtl' ? to * -1 : to;
    requestAnimationFrame(() => {
      this.slider.style.transform = `translateX(${pos}px)`;
      this.slider.style.webkitTransform = `translateX(${pos}px)`;
    });
  }
  translateX(to) {
    requestAnimationFrame(() => {
      this.slider.style.transform = `translateY(${to}px)`;
      this.slider.style.webkitTransform = `translateY(${to}px)`;
    });
  }
  getCarouselPointers(count) {
    let pointers = [];
    if (this.shortCarouselPagination && count >= 4) {
      pointers = [
        h("a", { class: cn('pointer', { active: this.current === 0 }) }),
        h("a", { class: cn('pointer', { active: this.current === 1 }) }),
        h("a", { class: cn('pointer', { active: this.current > 1 && this.current < count - 1 }) }),
        h("a", { class: cn('pointer', { active: this.current === count - 1 }) }),
      ];
    }
    else {
      for (let k = 0; k < count - this.itemsPerSlide + 1; k++) {
        pointers.push(h("a", { class: cn(`pointer_${k}`, { active: this.current === k }), onClick: () => this.slideTo(k) }));
      }
    }
    return pointers;
  }
  updateCurrentPosition(event) {
    this.current = event.detail.current;
  }
  recalculateSlides() {
    this.init();
  }
  recalculateSlidePosition() {
    var _a;
    this.slideWidth = this.parent.offsetWidth;
    this.itemWidth = this.slideWidth / this.itemsPerSlide;
    if ((_a = this.slides) === null || _a === void 0 ? void 0 : _a.length) {
      Array.from(this.slides).forEach((el) => {
        if (!this.differentWidthOfItems && this.slideCount > this.itemsPerSlide) {
          el.style.minWidth = `${this.itemWidth}px`;
        }
      });
    }
    this.pos = (this.operator * this.current * this.slideWidth) / this.itemsPerSlide;
    this.translateY(this.pos);
  }
  componentDidLoad() {
    this.init();
    this.initGesture();
    if (this.current > 0)
      this.slideTo(this.current);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  handleSlotChange() {
    this.init();
    this.slideTo(0);
  }
  render() {
    return [
      h("div", { class: "slim-slider-wrapper" }, h("div", { class: cn('slim-slides', {
          'small-height': this.smallCard,
          vertical: this.verticalPan,
        }), ref: (el) => (this.slider = el) }, h("slot", { onSlotchange: () => this.handleSlotChange() }))),
      this.showPointers && this.slideCount > this.itemsPerSlide && (h("div", { class: cn('carousel-pagination', {
          'carousel-pagination__above': this.showThumbnails,
          'small-point': this.smallPoint,
        }) }, this.getCarouselPointers(this.slideCount))),
      this.showButtons && this.slideCount > this.itemsPerSlide && (h("div", { class: cn({ vertical: this.verticalPan }, 'carousel-buttons') }, h("button", { class: "btn-link prev disabled", onClick: this.goToPrevious, ref: (el) => (this.prevBtn = el) }, this.verticalPan ? (h("pes-icon", { mirror: pesIconMirrorDirection.VERTICAL, size: pesIconSizes.MICRO }, "arrow2_down")) : (h("pes-icon", { size: pesIconSizes.LARGE, customStyle: { fontSize: '56px' } }, "arrow2_left"))), h("button", { class: "btn-link next", onClick: this.goToNext, ref: (el) => (this.nextBtn = el) }, this.verticalPan ? (h("pes-icon", { size: pesIconSizes.MICRO, customStyle: { fontSize: '40px' } }, "arrow2_down")) : (h("pes-icon", { size: pesIconSizes.LARGE, customStyle: { fontSize: '56px' }, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))))),
    ];
  }
  static get is() { return "pdp-slider"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["slider.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["slider.css"]
    };
  }
  static get properties() {
    return {
      "timing": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Represents the animation value between slides"
        },
        "attribute": "timing",
        "reflect": false,
        "defaultValue": "400"
      },
      "childrenClassName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Slider child slides elements"
        },
        "attribute": "children-class-name",
        "reflect": false,
        "defaultValue": "'pdp-slider > div, pdp-slider > pdp-product-card'"
      },
      "verticalPan": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "vertical-pan",
        "reflect": false,
        "defaultValue": "false"
      },
      "showButtons": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show or hide Next / Prev buttons"
        },
        "attribute": "show-buttons",
        "reflect": false,
        "defaultValue": "true"
      },
      "infinite": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Startover when the slider reaches the end"
        },
        "attribute": "infinite",
        "reflect": false,
        "defaultValue": "false"
      },
      "showPointers": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show or hide pager pointers"
        },
        "attribute": "show-pointers",
        "reflect": false,
        "defaultValue": "false"
      },
      "showThumbnails": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show or hide Thumbnails"
        },
        "attribute": "show-thumbnails",
        "reflect": false,
        "defaultValue": "false"
      },
      "itemsPerSlide": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "items-per-slide",
        "reflect": false,
        "defaultValue": "1"
      },
      "differentWidthOfItems": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "different-width-of-items",
        "reflect": false,
        "defaultValue": "false"
      },
      "sliderWidth": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "null | number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Set width of the slider. Can be used if while slider is initiating parent.offsetWidth is 0"
        },
        "attribute": "slider-width",
        "reflect": false,
        "defaultValue": "null"
      },
      "sliderHeight": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "null | number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Set height of the slider. Can be used if while slider is initiating parent.offsetHeight is 0"
        },
        "attribute": "slider-height",
        "reflect": false,
        "defaultValue": "null"
      },
      "activeSlide": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Set active slide"
        },
        "attribute": "active-slide",
        "reflect": false,
        "defaultValue": "0"
      },
      "panEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Enable swipe functionality"
        },
        "attribute": "pan-enabled",
        "reflect": false,
        "defaultValue": "true"
      },
      "direction": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Slider direction"
        },
        "attribute": "direction",
        "reflect": false,
        "defaultValue": "document.documentElement.dir || 'auto'"
      },
      "smallPoint": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "small-point",
        "reflect": false,
        "defaultValue": "false"
      },
      "smallCard": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "small-card",
        "reflect": false,
        "defaultValue": "false"
      },
      "shortCarouselPagination": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "false",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "short-carousel-pagination",
        "reflect": false
      },
      "goToNext": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(e?: any) => void",
          "resolved": "(e?: any) => void",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "(e?: any) => {\n      e && e.preventDefault();\n      if (this.direction === 'rtl') {\n        this.slideTo(Math.ceil(this.current + this.operator));\n      } else {\n        this.slideTo(Math.ceil(this.current - this.operator));\n      }\n    }"
      },
      "goToPrevious": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(e?: any) => void",
          "resolved": "(e?: any) => void",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "(e?: any): void => {\n      e && e.preventDefault();\n      if (this.direction === 'rtl') {\n        this.slideTo(Math.ceil(this.current - this.operator));\n      } else {\n        this.slideTo(this.current + this.operator);\n      }\n    }"
      }
    };
  }
  static get states() {
    return {
      "slideCount": {},
      "current": {}
    };
  }
  static get events() {
    return [{
        "method": "afterSlimInit",
        "name": "afterSlimInit",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "afterSlimSlide",
        "name": "afterSlimSlide",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "parent"; }
  static get watchers() {
    return [{
        "propName": "activeSlide",
        "methodName": "optionDidChange"
      }, {
        "propName": "itemsPerSlide",
        "methodName": "recalculateSlides"
      }, {
        "propName": "sliderWidth",
        "methodName": "recalculateSlidePosition"
      }];
  }
  static get listeners() {
    return [{
        "name": "afterSlimInit",
        "method": "updateCurrentPosition",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "afterSlimSlide",
        "method": "updateCurrentPosition",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
